export enum GetLoanableAmounts {
  REQUEST = '@loanableAmounts/getLoanableAmounts/request',
  SUCCESS = '@loanableAmounts/getLoanableAmounts/success',
  FAILED = '@loanableAmounts/getLoanableAmounts/failed',
}
